<template>
  <div class="view-container">
    <div class="staff-form-card display--flex">
      <div class="card">
        <div class="profile-image-card">
          <div>
            <a-avatar :size="100" style="background-color: var(--neutral-grey)"
                      :src="avatarSrc">
              <template #icon>
                <UserOutlined style="color: var(--border-grey); font-size: 45px" />
              </template>
            </a-avatar>
          </div>
          <div class="profile-short-info" v-if="form?.id">
            <div class="profile-info-header" v-if="getRight('admin')">
              <div class="status-tags">
                <a-tag color="green" v-if="statusUserActive">
                  Статус: Работает
                </a-tag>
                <a-tag class="red-tag" v-else>
                  Статус: В архиве
                </a-tag>
                <a-tag v-if="form.role">
                  Роль: {{ rolesTranslate[form.role] ?? '' }}
                </a-tag>
              </div>
              <div class="action-select-wrapper">
                <a-select
                    v-model:value="actionToApply"
                    :placeholder="'Действия с профилем'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                >
                  <a-select-option key="send_invite" value="send_invite">
                    Отправить приглашение
                  </a-select-option>
                  <a-select-option key="reset_password" value="reset_password">
                    Сбросить пароль
                  </a-select-option>
                  <a-select-option key="change_role" value="change_role">
                    Изменить роль
                  </a-select-option>

                  <a-select-option key="block" value="block" v-if="statusUserActive">
                    Архивировать
                  </a-select-option>
                  <a-select-option key="unblock" value="unblock" v-else>
                    Разблокировать
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div>
              <p class="profile-name">
                {{ (form.last_name ?? '') + ' ' + (form?.first_name ?? '') + ' ' + (form.patronymic ?? '') }}
              </p>
              <p class="profile-profession grey-text">
                {{ form?.job_title ?? '' }}
              </p>
            </div>

            <div class="upload-button" v-if="getRight('admin')">
              <a-upload
                  :before-upload="handleBeforeUpload"
                  :show-upload-list="false"
                  accept="image/*"
              >
                <a-button class="secondary-button">
                  <UploadOutlined/>
                  Загрузить фото
                </a-button>
              </a-upload>
            </div>

            <div class="action-select-wrapper mobile-select" v-if="getRight('admin')">
              <a-select
                  v-model:value="actionToApply"
                  :placeholder="'Действия с профилем'"
                  style="width: 100%;"
                  :not-found-content="'Нет данных'"
              >
                <a-select-option key="send_invite" value="send_invite">
                  Отправить приглашение
                </a-select-option>
                <a-select-option key="reset_password" value="reset_password">
                  Сбросить пароль
                </a-select-option>
                <a-select-option key="change_role" value="change_role">
                  Изменить роль
                </a-select-option>
                <a-select-option key="block" value="block" v-if="statusUserActive">
                  Архивировать
                </a-select-option>
                <a-select-option key="unblock" value="unblock" v-else>
                  Разблокировать
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div v-else class="spinner">
            <a-spin />
          </div>
        </div>
      </div>

      <div class="card info-card">
        <p class="card-info-header">Персональная информация</p>
        <div class="staff-form" v-if="!showForm">
          <div class="personal-row">
            <div class="info-item">
              <div class="info-label">Фамилия</div>
              <div class="info-value">{{ form.last_name }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">Имя</div>
              <div class="info-value">{{ form.first_name }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">Отчество</div>
              <div class="info-value">{{ form.patronymic }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">Почта</div>
              <div class="info-value">{{ form.email }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">Город</div>
              <div class="info-value">
                {{ staff?.city?.name ?? ''}}
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">Пол</div>
              <div class="info-value">
                {{ form.sex === 'male' ? 'Мужчина' : form.sex === 'female' ? 'Женщина' : '' }}
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">Год рождения</div>
              <div class="info-value">{{ form?.year ?? '' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">Название должности</div>
              <div class="info-value">{{ form.job_title }}</div>
            </div>
          </div>

          <div class="professional-row">
            <div class="info-item">
              <div class="info-label">Профессия</div>
              <div class="info-value">
                {{ professionOptions?.find((el) => el.id === form.profession_id)?.text ?? '' }}
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">Отрасль</div>
              <div class="info-value">
                {{ industriesOptions?.find((el) => el.id === form.industry_id)?.text ?? '' }}
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">Уровень должности</div>
              <div class="info-value">
                {{ positionOptions?.find((el) => el.id === form.position_id)?.text ?? '' }}
              </div>
            </div>
          </div>
        </div>

        <div class="info-item" v-if="staff?.groups && !showForm">
          <div class="info-label">Группы</div>
          <div class="tag-info">
            <a-tag v-for="(group) in staff?.groups" :key="group.id">
              {{ group.name }}
            </a-tag>
          </div>
        </div>

        <a-form v-else-if="showForm && getRight('admin')" layout="vertical" :model="form" @finish="submitForm">

          <div class="staff-form">
            <div class="personal-row">
              <a-form-item label="Фамилия" class="input-form-item" name="last_name">
                <a-input v-model:value="form.last_name" />
              </a-form-item>

              <a-form-item label="Имя" class="input-form-item"
                           name="first_name"
                           :rules="[{ required: true, message: 'Введите имя' }]"
              >
                <a-input name="first_name" v-model:value="form.first_name" />
              </a-form-item>

              <a-form-item label="Отчество" class="input-form-item" name="patronymic">
                <a-input v-model:value="form.patronymic" />
              </a-form-item>

              <a-form-item label="Почта" class="input-form-item" name="email"
                           :rules="[
                          { required: true, message: 'Введите почту' },
                          { type: 'email', message: 'Неверный формат' }]">
                <a-input name="email" v-model:value="form.email" placeholder="Введите почту"/>
              </a-form-item>

              <city-input @changeCity="(value) => form.city_id = value" :currentCity="staff?.city ?? null" />

              <div class="sub-row">
                <a-form-item label="Год рождения" class="input-form-item" name="year" required style="width: 100%">
                  <a-input-number v-model:value="form.year" placeholder="Год рождения"></a-input-number>
                </a-form-item>
                <a-form-item label="Пол" class="input-form-item" name="sex" required >
                  <a-select
                      v-model:value="form.sex"
                      :placeholder="'Пол'"
                      style="width: 100%;"
                      show-arrow
                  >
                    <a-select-option :key="'m'" value="male">
                      Мужчина
                    </a-select-option>
                    <a-select-option :key="'f'" value="female">
                      Женщина
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <a-form-item label="Название должности" class="input-form-item" name="job_title">
                <a-input v-model:value="form.job_title" />
              </a-form-item>
            </div>

            <div class="professional-row">
              <a-form-item label="Профессия" class="input-form-item" name="profession_id" required>
                <a-select
                    v-model:value="form.profession_id"
                    :placeholder="'Профессия'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in professionOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Отрасль" class="input-form-item" name="industry_id" required>
                <a-select
                    v-model:value="form.industry_id"
                    :placeholder="'Отрасль'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in industriesOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Уровень должности" class="input-form-item" name="position_id" required>
                <a-select
                    v-model:value="form.position_id"
                    :placeholder="'Уровень должности'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in positionOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <a-form-item label="Привязка к группам" class="group-select">
            <a-select
                v-model:value="form.groups"
                mode="multiple"
                :placeholder="'Не выбрано'"
                :not-found-content="'Нет данных'"
            >
              <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
                {{ e.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <div class="action-buttons">
            <a-row justify="start" :gutter="8">
              <a-col>
                <a-button class="primary-button" :loading="actionLoading" @click="submitForm">Сохранить изменения</a-button>
              </a-col>
              <a-col>
                <a-button class="secondary-button" @click="showForm = false">Отменить</a-button>
              </a-col>
            </a-row>
          </div>
        </a-form>
        <div class="staff-edit-button" v-if="getRight('admin') && !showForm">
          <a-button class="secondary-button" @click="showForm = true">
            <EditFilled />
            Редактировать
          </a-button>
        </div>
      </div>

      <div class="card activity-card">
        <StaffActivityCard v-if="form?.id" :userId="form.id"/>
      </div>
    </div>

    <BlockUserForm
        v-if="actionToApply === 'block' || actionToApply === 'unblock'"
        :open="actionToApply === 'block' || actionToApply === 'unblock'"
        :type="actionToApply"
        :currentActionUser="staff"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <ResetPasswordForm
        v-if="actionToApply === 'reset_password'"
        :open="actionToApply === 'reset_password'"
        :currentActionUser="staff"
        @submitted="clearCurrentUserAndAction"
        @close="clearCurrentUserAndAction"
    />

    <SendInviteForm
        v-if="actionToApply === 'send_invite'"
        :open="actionToApply === 'send_invite'"
        :currentActionUser="staff"
        @submitted="clearCurrentUserAndAction"
        @close="clearCurrentUserAndAction"
    />

    <ChangeStaffRole
        v-if="actionToApply === 'change_role'"
        :open="actionToApply === 'change_role'"
        :role="staff.role ?? ''"
        :userId="staff.id" ?? null,
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

  </div>
</template>

<script>
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import { useStore } from "vuex";
import { reactive, ref } from "@vue/reactivity";
import PreviewFileLoader from "@/components/Forms/Fields/PreviewFileLoader.vue";
import {computed, inject, onBeforeMount} from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
import useErrors from "../../mixins/useErrors";
import useProfileForm from "../../mixins/useProfileForm";
import Preloader from "@/components/Technical/Preloader.vue";
import useCheckRights from "../../mixins/useCheckRights";
import CustomCheckbox from "@/components/Forms/Fields/CustomCheckbox.vue";
import PopUpForm from "@/components/Popups/PopUpForm.vue";
import BaseTable from "@/components/Tables/BaseTable.vue";
import StaffChangePasswordModal from "@/feature/users/StaffChangePasswordModal.vue";
import QuotasModal from "@/views/ProductGroupReport/QuotasModal.vue";
import CityInput from "@/components/Forms/Fields/CityInput.vue";

import {UserOutlined, UploadOutlined, EditFilled} from "@ant-design/icons-vue";
import {message} from "ant-design-vue";
import rolesTranslate from "../../mixins/dictionaries/rolesTranslate";
import BlockUserForm from "@/feature/users/forms/BlockUserForm.vue";
import ResetPasswordForm from "@/feature/users/forms/ResetPasswordForm.vue";
import SendInviteForm from "@/feature/users/forms/SendInviteForm.vue";
import StaffActivityCard from "@/feature/users/StaffActivityCard.vue";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import ChangeStaffRole from "./ChangeStaffRole.vue";

export default {
  computed: {
    rolesTranslate() {
      return rolesTranslate
    }
  },
  components: {
    ChangeStaffRole,
    MiniPreloader,
    StaffActivityCard,
    SendInviteForm,
    ResetPasswordForm,
    BlockUserForm,
    CityInput,
    QuotasModal,
    StaffChangePasswordModal,
    BaseTable,
    PopUpForm,
    CustomCheckbox,
    CustomInput,
    PreviewFileLoader,
    // eslint-disable-next-line vue/no-unused-components
    CustomRadio,
    Preloader,
    UserOutlined,
    UploadOutlined,
    EditFilled
  },
  name: "staff-form",
  inject: ['imageUrl'],
  setup() {
    const store = useStore(),
      route = useRoute(),
      router = useRouter(),
      { setForm } = useProfileForm(),
      { getRight } = useCheckRights(),
      isPreloaderLoad = ref(false),
      isPreloaderSave = ref(false);
    const staff = computed(() => store.state.users.user),
      newStaffId = computed(() => store.state.users.userId),
      profile = computed(() => store.state.profile.profile),
      positionList = computed(() => store.state.test.positionList),
      professionList = computed(() => store.state.test.professionList),
      industriesList = computed(() => store.state.test.industriesList),
      companies = computed(() => store.state.company.companies),
      statusUserActive = ref(false);

    const actionLoading = ref(false);
    const showForm = ref(false);
    const showModal = ref(false);

    const actionToApply = ref(null);

    const form = reactive({
      id: null,
      last_name: null,
      first_name: null,
      patronymic: null,
      age: null,
      sex: null,
      profession_id: null,
      industry_id: null,
      position_id: null,
      city_id: null,
      image: null,
      currentImage: null,
      email: null,
      password: null,
      password_change_required: false,
      company: null,
      role: null,
      company_id: null,
      userActive: null,
      job_title: null,
      year: null,
      groups: [],
    });

    const professionOptions = ref([]),
      industriesOptions = ref([]),
      positionOptions = ref([]),
      roleOptions = ref([{ id: "staff", text: "Сотрудник" }]),
      companyOptions = ref([]);

    const handleBeforeUpload = async (file) => {
      let tempImage =  await fileToBase64(file);
      form.currentImage = tempImage;
      form.image = tempImage;
      submitStaff();
      return false;
    };

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
      });

    const allGroups = computed(() => store.state.group.groups);
    const groups = ref([]);

    onBeforeMount(() => {
      if (route.params.id) {
        isPreloaderLoad.value = true;
        store.dispatch("users/getUser", route.params.id).then(() => {
          setForm(staff.value, form);
          isPreloaderLoad.value = false;

          store.dispatch("getStatusActiveUser", staff.value.id).then(() => {
            statusUserActive.value = store.state.statusUserActive;
          });

          form.groups = staff.value?.groups?.map((el) => el.id);
        });
      } else {
        store.dispatch("profile/getProfile").then(() => {
          setForm(profile.value, form);

          store.dispatch("getStatusActiveUser", profile.value.id).then(() => {
            statusUserActive.value = store.state.statusUserActive;
          });
        });
      }

      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });
      });

      store.dispatch("test/getPositionList").then(() => {
        if (profile.value) {
          if (profile.value.role == "admin")
            roleOptions.value = [
              { id: "staff", text: "Сотрудник" },
            ];
          if (profile.value.role == "superadmin")
            roleOptions.value = [
              { id: "staff", text: "Сотрудник" },
              { id: "superadmin", text: "Суперадмин" },
              { id: "admin", text: "HR Администратор" },
              { id: "hr_department", text: "HR Подразделения" },
              { id: "private_person", text: "Частное лицо" },
            ];
        }
        positionOptions.value = positionList.value.map((position) => {
          return { id: position.id, text: position.text };
        });
      });

      store.dispatch("test/getProfessionList").then(() => {
        professionOptions.value = professionList.value.map((profession) => {
          return { id: profession.id, text: profession.text };
        });
      });

      store.dispatch("test/getIndustriesList").then(() => {
          industriesOptions.value = industriesList.value.map((industry) => {
              return { id: industry.id, text: industry.text };
          });
      });
    });

    const submitForm = (event) => {
      form.age = calculateAge();

      event.preventDefault();
      if (
          !form.last_name ||
          !form.first_name ||
          !form.patronymic ||
          !form.sex ||
          !form.job_title ||
          !form.profession_id ||
          !form.position_id ||
          !form.city_id ||
          !form.industry_id ||
          !form.year ||
          !form.age
      ) {
        message.error('Не все поля заполнены');
        return;
      }

      submitStaff();
    };

    const calculateAge = () => {
      const yearNow = new Date().getFullYear();
      if (!Number.isFinite(form.year) || form.year < 1900 || form.year > yearNow) return null;
      return yearNow - form.year;
    }

    const clearCurrentUserAndAction = () => {
      actionToApply.value = null;
      showModal.value = false;
      showForm.value = false;
    }

    const statusError = ref({
      email: false,
    });

    const submitStaff = () => {
      actionLoading.value = true;
      isPreloaderSave.value = true;
      if (route.params.id) {
        store
          .dispatch("users/updateUser", {
            id: route.params.id,
            form: { ...form },
          })
          .then((data) => {

            if (data?.status && data?.status === 422) {
              message.error('Произошла ошибка');
              Object.entries(data.data).forEach(([field, messages]) => {
                statusError.value[field] = messages[0];
                message.error(messages[0]);
              });
            } else {
              setForm(staff.value, form);
              clearCurrentUserAndAction();
              message.success('Данные сохранены');
              fetchAfterSubmit();
            }
          })
          .catch(() => {
            message.error('Произошла ошибка');
          })
          .finally(() => {
             actionLoading.value = false;
          });
      }
    };

    const imageUrl = inject("imageUrl");

    const avatarSrc = computed(() => {
      if (form.image) {
        return form.currentImage;
      } else if (form.currentImage) {
        return `${imageUrl}/storage/${form.currentImage}`;
      } else {
        return undefined;
      }
    });

    const fetchAfterSubmit = () => {
      clearCurrentUserAndAction();
      store.dispatch("users/getUser", route.params.id).then(() => {
        setForm(staff.value, form);
      });
    }

    return {
      form,
      submitStaff,
      staff,
      route,
      professionOptions,
      roleOptions,
      companyOptions,
      positionOptions,
      router,
      profile,
      newStaffId,
      isPreloaderLoad,
      isPreloaderSave,
      getRight,
      industriesOptions,
      statusUserActive,
      showModal,
      handleBeforeUpload,
      avatarSrc,
      actionToApply,
      submitForm,
      showForm,
      actionLoading,
      clearCurrentUserAndAction,
      fetchAfterSubmit,
      groups,
      statusError
    };
  },
};
</script>

<style lang="scss" scoped>
.checkbox_wrapper {
  margin-left: 15px;

  @media (max-width: 1000px) {
    margin-top: 15px;
  }

  @media (max-width: 972px) {
    margin-left: 5px;
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
}

.card {
  margin-bottom: 16px;
}

.staff-form-card {
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 769px) {
    .form-group {
      margin: 25px -15px;
    }
  }

  &__radios {
    margin-top: 25px;

    .form-group:not(:last-child) {
      margin-right: 2rem;
    }
  }

  &__organization {
    flex: 0 1 20%;
    padding: 25px 40px 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &__staff {
    flex: 1 0 80%;
  }

  &__staff,
  &__organization {
    margin-bottom: 0;
  }

  &__title {
    display: block;
    font-size: 26px;
    padding-bottom: 10px;
  }

  &__text {
    font-size: 27px;
    display: block;
    padding-bottom: 10px;
    max-width: 90%;
  }

  &__col {
    flex: 0 1 50%;
    padding: 0 10px;
  }

  &__staff-info-mobile {
    display: none;
  }

  @media (max-width: 1360px) {
    width: 100%;
  }

  @media (max-width: 1400px) {
    &__inputs {
      flex-direction: column;
    }
    &__staff-info {
      display: none;
    }
    &__staff-info-mobile {
      display: block;
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    &__btns {
      flex-direction: column;
      row-gap: 10px;
    }
  }

  @media (max-width: 425px) {
    &__photo-area {
      margin: 0 !important;
    }
    &__organization {
      padding: 20px 20px 0;
    }
  }
}

.profile-name {
  font-size: 20px;
  font-weight: 600;
}

.profile-image-card {
  display: flex;
  column-gap: 20px;
  row-gap: 20px;
  min-height: 120px;
  width: 100%;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.profile-profession {
  font-size: 14px;
}

.info-card {
  font-size: 14px;
}

.profile-short-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 8px;

  @media (max-width: $mobile-breakpoint) {
    align-items: center;
  }
}

.profile-info-header {
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    align-items: center;
  }

  .action-select-wrapper {
    @media (max-width: $mobile-breakpoint) {
      display: none;
    }
  }
}

p {
  margin: 0 0 5px;
}

.upload-button {
  margin-top: auto;

  @media (max-width: $mobile-breakpoint) {
    margin-top: 8px;
    width: 100%;

    :deep(.ant-upload-select) {
      width: 100%;
    }

    button {
      width: 100%;
    }
  }
}

.card-info-header {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
}

.status-tags, .tag-info {
  margin-bottom: 8px;
  display: flex;
  row-gap: 5px;
  flex-wrap: wrap;
}

.tag-info {
  margin-top: 5px;
}

.action-select-wrapper {
  width: 220px;

  @media (max-width: $mobile-breakpoint) {
    width: 100%;
    text-align: center;
  }
}

.mobile-select {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
    margin-top: 12px;
  }
}

.info-label {
  color: var(--grey-text);
}

.info-value {
  font-weight: 600;
}

.staff-form {
  max-width: 700px;
  display: flex;
  column-gap: 16px;

  .professional-row, .personal-row {
    width: 50%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 10px;

    .professional-row, .personal-row {
      width: 100%;
    }
  }

  :deep(.ant-input-number) {
    width: 100%;
  }
}

.sub-row {
  display: flex;
  column-gap: 10px;

  .ant-form-item {
    width: 50%;
  }
}

:deep(.ant-form-vertical .ant-form-item-label) {
  padding: 0 0 4px;
}

.info-item {
  margin-bottom: 12px;
}

.action-buttons {
  margin-top: 5px;
  @media (max-width: 768px) {
    .ant-row {
      flex-direction: column;
      row-gap: 10px;
    }

    .ant-row button{
      width: 100%
    }
  }
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

:deep(.group-select) {
  margin: 15px 0;
}

.spinner {
  width: 100%;
  text-align: center;
  margin: auto;
}

.view-container {
  padding-top: 0;
}
</style>
